import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UserGroup, UsersApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export type AddUserGroupParams = {
  userGroup: UserGroup
}

export const useMutationAddUserGroup = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: AddUserGroupParams) => {
      return await baseClient
        .getApi(UsersApi)
        .addUserGroup({
          userGroup: params.userGroup,
        })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.userGroupsAll })
    },
  })
}
